module.exports = __webpack_public_path__ + "img/insurance-umbrella.8449298.webp";